var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 10.6667L7.99998 8M7.99998 8L10.6666 10.6667M7.99998 8V14M13.3333 11.1619C14.1476 10.4894 14.6666 9.47196 14.6666 8.33333C14.6666 6.30829 13.025 4.66667 11 4.66667C10.8543 4.66667 10.718 4.59066 10.6441 4.46516C9.77469 2.98989 8.1696 2 6.33331 2C3.57189 2 1.33331 4.23858 1.33331 7C1.33331 8.3774 1.89028 9.62472 2.79128 10.529",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.418bb8bfab1a919fd1e079b13c7912b8.svg";
export { ForwardRef as ReactComponent };